// extracted by mini-css-extract-plugin
export default {"container":"container-KiioNfyO","points":"points-weLc5tmg"};